import { Outlet, Navigate } from 'react-router-dom';

import ProfilePage from 'src/pages/profile/ProfilePage';
import GroupUsersPage from 'src/pages/groupUsers/GroupUsersPage';
import TicketDetailsPage from 'src/pages/ticketDetails/TicketDetailsPage';

import SimpleLayout from '../layouts/simple';
// layouts
import DashboardLayout from '../layouts/dashboard';
//

import Page404 from '../pages/404/Page404';
import LoginPage from '../pages/Login/loginPage';
import TicketsPage from '../pages/tickets/TicketsPage';
import CustomerDashboard from '../pages/dashboards/CustomerDashboard';
import CreateTicketPage from '../pages/ticketCreation/CreateTicketPage';
import { ProtectedRoute } from '../components/protected-route/ProtectedRoute';
// ----------------------------------------------------------------------

const CustomerRoutes = {
  path: '/',
  element: <Outlet />,
  children: [
    {
      path: '/dashboard',
      element: (
        <ProtectedRoute>
          <DashboardLayout />
        </ProtectedRoute>
      ),
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: 'app', element: <CustomerDashboard /> },
        { path: 'tickets', element: <TicketsPage /> },
        { path: 'profile', element: <ProfilePage /> },
        { path: 'newTicket', element: <CreateTicketPage /> },
        { path: 'myGroups', element: <GroupUsersPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    { path: 'tickets/:ticketId', element: <TicketDetailsPage /> },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/dashboard/app" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ],
};
export default CustomerRoutes;
